<template>
    <UiFaqs :blok="blok" />
</template>

<script setup lang="ts">
import type { IFaqSection } from '@nuxt-monorepo/ui/types/components/Faqs';

const { blok } = defineProps<{ blok: IFaqSection }>();
</script>

<style lang="postcss"></style>
